var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtlasIconSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79335 10.6056C5.48002 7.25427 8.44596 4.73355 12.0011 4.73355C15.5563 4.73355 18.52 7.25427 19.2066 10.6056H24C23.269 4.62944 18.1744 0 12.0011 0C5.82778 0 0.73318 4.62723 0 10.6056H4.79335Z",
    fill: "#D92D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0009 7.70386C14.4242 7.70386 16.3867 9.6686 16.3867 12.0896C16.3867 14.5107 14.422 16.4776 12.0009 16.4776C9.57988 16.4776 7.61293 14.5129 7.61293 12.0896C7.61293 9.66638 9.57767 7.70386 12.0009 7.70386Z",
    fill: "#DA291C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.5759C0.730965 19.5521 5.82557 24.1816 12.0011 24.1816C18.1767 24.1816 23.269 19.5521 24 13.5759H19.2066C18.52 16.9273 15.554 19.448 12.0011 19.448C10.9047 19.448 9.8658 19.2088 8.93106 18.7791L4.77342 19.8932L5.8012 16.0523C5.32497 15.3081 4.97721 14.4708 4.79557 13.5759H0.00221721H0Z",
    fill: "#D92D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasIconSelect);
export default __webpack_public_path__ + "static/media/AtlasIconSelect.87c4f6290baebffb59bea7adf1621a0b.svg";
export { ForwardRef as ReactComponent };